import { render, staticRenderFns } from "./PostEvaluationAssessmentPart.vue?vue&type=template&id=1f4397ec&"
import script from "./PostEvaluationAssessmentPart.vue?vue&type=script&lang=js&"
export * from "./PostEvaluationAssessmentPart.vue?vue&type=script&lang=js&"
import style0 from "./PostEvaluationAssessmentPart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports